export const SET_FEEDBACK_TABLE = "SET_FEEDBACK_TABLE"
export const SET_TAB_STATUS = "SET_TAB_STATUS"
